export default {
  app_name: '메이드',
  app_error: {
    title: '예상치 못한 오류가 발생했습니다.',
    msg: '담당 팀에 오류가 전송되었습니다. 앱을 닫고 다시 시작하세요!',
    network: '네트워크 통신 오류가 발생했습니다.',
    other_device_login: '다른 기기에서 로그인되었습니다.',
    image_not_supported: '지원하지 않는 이미지입니다....',
  },
  app_exit: '\'뒤로\' 버튼을 한번 더 누르면 종료됩니다.',
  permissions: {
    splash:
      '이 앱에는 다음 권한이 필요합니다.\n' +
      "1. 기기의 저장소에 액세스하여 앱의 내부 데이터를 저장합니다.\n" +
      '2. 사용자 식별을 위해 전화 번호 및 이메일 주소에 대한 액세스를 허용합니다.',
    splash_denied: '이 앱은 필요한 모든 권한이 부여되면 정상적으로 작동 할 수 있습니다.',
    location: '이 앱은 주변 회원을 찾기 위해 위치 정보에 액세스하려고합니다.',
    camera_0: '이 앱은 게시물에 게시 할 사진을 찍기 위해 카메라에 액세스하려고합니다.',
    camera_1: '이 앱은 관리자에게 전송할 사진을 찍기 위해 카메라에 접속하려고합니다.',
    camera_2: '이 앱은 프로필에 등록 할 사진을 찍기 위해 카메라에 액세스하려고합니다.',
  },
  downloaded_files_desc: 'Download상태: %s/%s',
  common: {
    order_type: "정렬방식",
    order_asc: "과거순",
    order_desc: "최신순",
    update_all: "전체 갱신",
    remove_price: '금액지움',
    download: "다운로드",
    ok: '확 인',
    cancel: '취소하기',
    cancel1: '취 소',
    delete: '삭제하기',
    delete1: '삭제',
    agree: '동의',
    complete: '완료',
    complete1: '작성완료',
    no: 'No',
    save: '저장하기',
    confirm: '확 인',
    install: '설치',
    won: '원',
    man_won: '%s만원',
    man_won1: '%s만 원',
    bak_man_won: '%s백만원',
    euk_won: '%s억 만원',
    euk_man_won: '%s억 %s만원',
    k: '%s억',
    save_success: '저장되었습니다.',
    update_success: '수정되었습니다.',
    charge_success: '충전되었습니다.',
    temporary_save_success: '임시저장 되었습니다.',
    delete_success: '삭제되었습니다.',
    empty_hint: '자료가 없습니다.',
    apply: '적용하기',
    apply1: '적용',
    copy: '복사',
    modify: '수정하기',
    modify1: '수정',
    reset: '초기화',
    p: '%s평',
    attach: '첨부하기',
    update_maemul_title: '갱신이 필요한 매물이 있습니다.',
    update_maemul_desc: '자동 숨김까지 5일 이내의 매물이 있습니다.\n',
    update_maemul_environment: '갱신 기간이 지나면 ‘숨김’ 처리됩니다.',
    move: '이동',
    upload_image_error: '업로드 중 오류가 발생했습니다.\n다시 등록해주세요.',
    new_version_exist: '새로운 버전이 출시되었습니다.\n\n설치하시겠습니까?',
    deleted_hidden_site: '매물 관리자에 의해 \'숨김\' 처리된 현장입니다.',
    select: '선택',
    copy_phone_success: '연락처가 복사되었습니다.',
    copy_address_success: '주소가 복사되었습니다.',
    copy_account_success: '계좌번호가 복사되었습니다.',
    copy_account_no: '메이드 482601-01-158927'
  },
  image_picker: {
    title: '사진 선택',
    camera: '카메라',
    gallery: '갤러리'
  },
  maemul_type: [
    '빌라/연립/다세대',
    '도시형 생활주택',
    '오피스텔',
    '아파트',
    '타운하우스',
    '단독주택',
    '근린생활시설',
  ],
  maemul_type_short: [
    '빌라',
    '도생',
    '오피',
    '아파트',
    '타운',
    '단독',
    '근생',
  ],
  parking_info: [
    // '자주식주차',
    '일렬주차',
    '겹주차',
    '기계주차',
    '주차불가',
  ],
  trans_type: [
    '매매',
    '전세',
    '투자',
    '월세',
  ],
  trans_type_short: [
    '매',
    '전',
    '투',
    '월',
  ],
  trans_type1: [
    '매매',
    '전세',
    '투자',
    '월세',
  ],
  trans_type_ho: [
    '매매',
    '전세',
    '투자',
    '월세',
  ],
  dongsi: '매/전',
  splash: {
    title: '부동산계약\n메이드에서\n메이드하자',
    brand: '메이드',
    ceo_label: '대표자명',
    ceo_name: '강지현',
    corp_tel_label: '사업자 번호',
    corp_tel: '185-33-01079',
    mail_order_business: '통신판매신고',
    mail_order_business_no: '2021-서울강남-03347',
    corp_address_label: '사업지 주소',
    corp_address: '서울특별시 강남구 언주로134길 14, ES타워 202호',
    qna_center_label: '고객센터',
    qna_address: 'pf.kakao.com/_xgctis',
    tel_label: '전화번호',
    tel: '070-8998-1276',
    provision1: '이용약관',
    provision2: '개인정보 처리방침'
  },
  login: {
    login: '로그인',
    phone_placeholder: '휴대폰 번호를 입력하세요.',
    maemul_placeholder: '매물번호를 입력하세요.',
    send_auth_num: '인증번호 발송',
    auth_placeholder: '인증번호를 입력하세요.',
    auth_num_request: '인증번호를 발송하세요.',
    confirm_num: '인증번호 확인',
    signup: '회원가입',
    auth_num_sent: '인증번호가 발송되었습니다.',
    auth_num_incorrect: '인증번호가 틀립니다.다시 확인해주세요.',
    time_out: '인증시간이 초과되었습니다.',
    login_success: '메이드에 등록된 번호로\n' +
      '추가인증 절차 없이\n' +
      '바로 가입 가능합니다.'
  },
  signup_info: {
    business_card_photo: '명함 사진',
    bs_regist: '+ 명함 등록',
    photo_guide: '휴대폰 인증은 명함 연락처와 동일해야 합니다.',
    photo_guide2: '반드시 실물 명함을 촬영해 첨부해주세요.',
    affiliation_placeholder: '소속을 입력하세요.',
    name_placeholder: '이름을 입력하세요.',
    pick_card_photo: '명함을 첨부해주세요.',
    all_info: '입력되지 않은 정보가 있습니다.',
    next_step: '다음단계',
    auth_phone: '휴대폰번호를 인증해주세요.',
    signup_under_review: '가입 신청이 완료되었습니다.\n가입 승인은 매일 순차적으로 진행됩니다.',
    cert_match: '인증번호가 일치합니다.',
    cert_match_admin: '관리자에 의하여 인증된 번호입니다.',
    cert_not_match: '인증번호가 일치하지 않습니다.'
  },
  signup_quiz: {
    title: ' 부동산업 종사자 인증 질문',
    apply_subscription: '가입신청',
    dlg_title: '가입신청을 하시겠습니까?',
    dlg_content: '입력하신 정보가 다르거나 답안이 틀릴 경우',
    dlg_content1: '다음 날(%s) 다시 신청하실 수 있습니다.',
    dlg_content2: '▶ 가입신청이 거절되는 경우 ◀<br>★1. 실물 명함을 촬영한 사진이 아닐 때<br>★2. 명함 속 연락처와 인증한 연락처가 다를 때<br>3. 인증 질문에 대한 답안이 틀릴 때',
    select_answer: '각 문의사항에 대한 답을 선택하세요.'
  },
  menu: {
    home: '홈',
    interest: '관심매물',
    interest1: '관심',
    map: '지도',
    community: '커뮤니티',
    more: '더보기',
  },
  admin: {
    show_admin: '관리자 화면',
    hide_admin: '사용자 화면',
    sale: '등록된 매물',
    update_sale: '업데이트',
    notice: '알림',
    community: '커뮤니티',
    delete: '삭제하기',
    update: '업데이트',
    update1: '갱신',
    modify_sale: '매물수정',
    confirm_delete_sale: '해당 매물을 삭제하시겠습니까?',
    confirm_delete_sale_content: '삭제한 매물은 복구가 불가능합니다.',
    msg_user_find_success: '%s 이 전화번호로 검색되었습니다.',
    lock_unlock_setting: '잠금/해제 관리자',
    lock_unlock_apply: '잠금/해제 적용',
    password: '비밀번호',
    password_not_matched: '비밀번호가 올바르지 않습니다.',
    unlock_hint: '먼저 잠금해제해주세요.'
  },
  admin_member: {
    mobile_phone: '휴대폰 번호',
    maemul_number: '매물 번호',
    member_manage: '회원번호 관리',
    site_manage: '매물 관리',
    add: '추가하기',
    db_view: '데이터베이스 보기',
    remove: '제거하기',
    reject_subscription: '가입제한',
    accept_subscription: '제한풀기',
    write_limit_5: '5일 글쓰기 제한',
    login_limit_5: '5일 로그인 제한',
    confirm_remove: '회원을 DB에서 지우시겠습니까 ?',
    confirm_reject_member: '회원의 가입을 제한하시겠습니까?',
    confirm_accept_member: '회원의 가입제한을 해제하시겠습니까?',
    confirm_5_day_write_limit: '회원의 글쓰기를 5일동안 제한하시겠습니까?',
    confirm_5_day_login_limit: '회원의 로그인을 5일동안 제한하시겠습니까?',
    msg_add_phone_success: '전화번호가 DB에 등록되었습니다.',
    msg_remove_user_success: 'DB에서 삭제되었습니다.',
    msg_limit_user_success: '전화번호가 제한되었습니다.',
    msg_lift_user_success: '제한이 해지되었습니다.',
    msg_write_limit_success: '%s 00:00까지 글쓰기가 제한되었습니다.',
    msg_login_limit_success: '%s 00:00까지 로그인이 제한되었습니다.',
    number: '순번',
    affiliation: '소속',
    name: '이름',
    contacts: '연락처',
    export_excel: '데이터 전체 내보내기',
  },
  admin_subscription: {
    subscription_title: '가입 승인/거절',
    reject: '거절',
    approve: '승인',
    confirm_reject: '가입을 거절하시겠습니까?',
  },
  admin_point: {
    point_placeholder: '포인트를 입력해주세요.',
    period_placeholder: '이용기간을 입력해주세요.',
    point_manage_title: '포인트, 이용기간 제공',
    point_manage_title1: '포인트, 이용기간 관리',
    point: '포인트',
    offer: '제공',
    deduction: '차감',
    usage_period: '이용기간',
    msg_offer_point_success: '제공되었습니다.',
    msg_deduction_point_success: '포인트가 차감되었습니다.',
    msg_offer_period_success: '이용기간이 설정되었습니다.',
    msg_deduction_period_success: '이용기간이 차감되었습니다.',
    confirm_offer_point: '%s\n%s님께 %s포인트를 제공하시겠습니까?',
    confirm_deduction_point: '%s\n%s님에게 포인트를 줄이시겠습니까?',
    confirm_offer_period: '%s\n%s님에게 %s일의 이용기간을 제공하시겠습니까?',
    confirm_deduction_period: '%s\n%s님에게 %s일의 이용기간을 줄이시겠습니까?',
  },
  admin_point_setting: {
    point_setting_title: '포인트, 이용권 적용',
    point_setting_title1: '포인트, 이용권 적용',
    made_community_writing: '메이드+ 커뮤니티 글쓰기',
    send_made_notification: '메이드+ 알림 보내기',
    community_writing_push: '푸시 기능 커뮤니티 글쓰기',
    send_push_notification: '푸시 기능 알림 보내기',
    one_month_ticket: '한달 이용권',
    current_point: '현재 포인트',
    point_to_apply: '적용할 포인트',
    convert_ticket: '이용권 전환',
    free: '무료',
    pay: '유료',
    show_ticket: '이용권 표시',
    show: '표시',
    hide: '숨김',
    msg_update_success: '적용되었습니다.',
    confirm_change_point: '포인트를 %s에서 %s로 변경합니다.',
    confirm_change_ticket: '이용권을 %s에서 %s로 처리합니다.',
    confirm_change_ticket_visible: '이용권을 %s 처리합니다.',
    confirm_change_monthly_point: '한달 이용권의 포인트를%s에서 %s로 변경합니다.',
  },
  admin_write: {
    write_manage_title: '작성 글 관리',
    write_manage_title1: '작성글 관리',
  },
  admin_view_member: {
    view_member_title: '회원정보 보기',
    business_card_photo: '명함 사진',
    belong: '소속',
    name: '이름',
    sign_up_date: '최초 가입일',
    last_access_date: '최근 접속일',
    register_sale_count: '매물 등록 수',
    community_post_count: '커뮤니티 글 수',
    noti_regist_count: '알림 등록 수',
    warned_count: '경고 받은 횟수',
    remaining_point: '잔여 포인트',
    point_charged: '충전한 포인트',
  },
  admin_ads: {
    ads_manage_title: '메인광고 설정',
    main_content_detail: '운영자가 쓰고 싶은 말',
    main_content_hint: '운영자가 쓰고 싶은 말 미리 보기',
    main_image_size_hint: '\n이미지 크기: ',
    text: '텍스트',
    image: '이미지',
    apply: '적용',
    reset: '초기화',
    connect_detail: '연결내용',
    link: '링크',
    advertising: '광고',
    sequence: '순차',
    random: '랜덤',
    ads_number: '광고번호',
    ads_image_hint: '광고 이미지 미리보기',
    attach: '첨부',
    delete: '삭제',
    duration_sec: '지속시간(초)',
    ad_period: '광고기간(일)',
    select_ads_hint: '먼저 광고를 선택해주세요.',
    ad_duration_input_hint: '지속시간을 설정해주세요',
    ad_period_input_hint: '광고기간을 입력하여 주세요.',
    connect_content_input_hint: '연결정보를 입력하여 주세요.'
  },
  admin_super: {
    admin_manage_title: '관리자 추가, 권한 조절',
    save_authority: '관리자 권한 조절',
    msg_search_user_by_phone: '먼저 휴대폰번호로 회원을 검색하여 주세요.',
  },
  admin_sale_req: {
    sale_req_title: '매물 등록 중인 회원',
    search: '조회',
    drop_off: '중도이탈',
    temporary_save: '임시저장',
    today: '오늘',
    yesterday: '어제',
    day_before_yesterday: '그제',
  },
  admin_sale_log: {
    sale_log_title: '회원번호 로그인',
    sale_completed_title_old: '불량신고',
    sale_completed_title: '현장제보',
    member_login_title: '회원번호 로그인',
    log_in_with_other_id: '회원번호로 로그인',
    move: '이동',
    login: '로그인',
    // search_hint: '분양완료 제보 된 매물 보기',
    search_hint: '현장제보 검색',
    report_member_number: '회원번호',
    reported_site_name: '현장명',
    reported_date: '날짜',
  },
  admin_site: {
    site_title: '매물 관리'
  },
  home: {
    popup: '팝업',
    new_open_site: '관심지역 오픈현장',
    monthly_site: '월별 목록',
    monthly_site1: '월별 현장목록',
    monthly_site_desc: '*관심지역 설정 내의 현장만 표시됩니다.',
    regional_setting: '지역 설정',
    open_date: '오픈',
    location_noti: '현장 알림',
    today_reminder: '알림 목록',
    usage_date_limited: "이용권이 없습니다.",
  },
  region_popup: {
    title: '관심지역 설정',
    desc: '*전체 설정/해제는 왼쪽 지역명을 한번 더 눌러주세요.'
  },
  interest: {
    recently_view: '최근 본 매물',
    favorite_sale: '관심 설정한 매물',
    reg_date: '등록일자',
    open_date: '오픈일자',
    supply_meal: '식대지급',
    trading: '매매',
    trading1: '매매',
    charter: '전세',
    relief: '안 심',
    smb: '중기청',
    invest: '투자',
    monthly: '월세',
    desc_monthly: '월세 있음',
    call_phone: '연락처복사',
    completion_report: '완료제보',
    navi_connect: '네비연결',
    copy_address: '주소복사',
    site_notify: '현장알림',
    no_contact: '연락처가 없습니다.',
    report_title: '해당 매물을 신고하시겠습니까?',
    report_confirm: '정확한 제보의 경우 1,000포인트가 제공됩니다.',
    report_confirm1: '허위 또는 불량 등록된 매물만 신고해주세요.',
    report_confirm_click: '\n현장 확인 후 포인트가 지급됩니다.',
    report_confirm_click2: '해당 매물이 신고되었습니다.',
    type: '%s타입',
    no_room: '-'
  },
  site_detail: {
    my_field_memo: '내 메모',
    my_memo_placeholder: '현장 관련 내용 또는 첨부할 이미지가 있으시면 \n이용해주세요. (본인만 확인 가능)',
    site_type: '매물유형',
    building_info: '단지정보',
    build_info: '총 %s개동, %s세대',
    parking_info: '주차정보',
    inlay_picture: '속지 사진 ',
    open_date_new: '오픈일자 %s',
    open_date_general: '준공일자 %s',
    update_date: '업데이트 %s',
    room_toilet_num: '방%s/화%s',
    room_toilet_num_short: '%s/%s',
    r_single_hit: '실거주 %s',
    floor: '층',
    ho: '',
    type: '유형',
    area: '면적(평)',
    lease_price: '임대가(만원)',
    remark: '비고',
    about_area: '약 %s평',
    teras: '테라스',
    teras_short: '테',
    household_info: '세대 정보',
    done: '완료',
    meal: '식대',
    room: '방',
    toilet: '화장실',
    toilet1: '화',
    parcel_out: '매매',
    collateral_short: '실입',
    collateral_short1: '담보',
    collateral: '담보실입',
    private: '전용',
    private1: '전용면적',
    real_size: '실평',
    real_size1: '실제평수',
    dup_teras: '복/테',
    dup_teras2: '복층/테라스',
    location_info: '주변시설 및 거리뷰/거리재기',
    here: '여기',
    more_locations: '지도에서 확인하기',
    memo: '매물내용',
    memo1: '현장 내용',
    group_site_set: '그룹매물 설정',
    group_share_space: '그룹 공유',
    person_manager: '1인 관리',
    call_phone: '연락처복사',
    dup: '복',
    // represent_photo: '대표 사진',
    represent_photo: '대표 현장사진',
    no_recent_notification: '최근알림 없음',
    recent_notification_days: '최근알림 %s일 전',
    recent_notification_today: '최근알림 오늘',
    view_notify: '알림보기',

    site_inquire: '현장문의',
    site_inquire_view: '현장문의 보기',
    site_inquire_fee: '수수료 문의',
    site_inquire_short: '문의',
    desc_inquire_site: '현장문의',
    already_reported_today: '오늘 이미 제보된 현장입니다.',
    already_reported_today_ho: '오늘 이미 제보된 세대입니다.',
    require_field_desc: ' 는 필수 입력사항입니다.',
    supply_meal_title: '오픈일자에 식대(현금) 지급을 하십니까?',
    supply_meal_content1: '사은품(ex 수건, 다과, 텀블러 등)이 아닌',
    supply_meal_content2: '‘식대(현금)’일 경우에만 체크해주세요.',
    residence_type: '거주여부',
    residence: '거주',
    vacancy: '공실',
    open_date: '준공연도',
    dup_teras1: '복층/테라스',
    new_site_short: '[신축]',
    general_site_short: '[구옥]',
  },
  room_info_popup: {
    gae: '개',
    veranda: '베란다',
    utility_room: '다용도실',
    duplex: '복층',
    duplex_short: '복',
    private_size: '전용',
    pyong: '평',
    sale_price: '매매가',
    parcel_price: '매매가',
    parcel_price1: '매매',
    man_won: '만원',
    invest: '투자금',
    individual_photos: '세대 사진',
    memo: '세대 내용'
  },
  map: {
    my_site: '나의매물',
    group_site: '그룹매물',
    transfer_site: '매물이전',
    all: '전체',
    shape: '형태',
    room: ' 방 ',
    area: '면적',
    r: ' R ',
    period: '기간',
    filter_all: '전체 필터',
    convenience_facility: '편의시설',
    safety_facility: '안전시설',
    district_info: '학군정보',
    bus_sta: '공공기관',
    subway_sta: '지하철역',
    mart: '마 트',
    convenience: '편의점',
    bank: '은행',
    park: '주차장',
    drug_store: '약국',
    safety: '치안',
    cctv: 'CCTV',
    child_center: '어린이집',
    kindergarden: '유치원',
    elementary_sc: '초등학교',
    middle_sc: '중학교',
    high_sc: '고등학교',
    classification: '매물구분',
    new_open_site: '신축현장',
    new_open_site_short: '신축',
    general_site: '구옥매물',
    general_site_short: '구옥',
    room_nums: '방 개수',
    room_structure: '방 구조',
    price: '가격',
    multi_selection: '(중복 선택 가능)',
    filter_notice: '*새 오픈현장은 표시된 가격범위를 벗어난 경우 조회되지 않습니다.',
    one_room: '원룸',
    one_half_room: '1.5룸',
    two_room: '2개',
    three_room: '3개',
    four_room_more: '4개 이상',
    four_room: '4개',
    more: '이상',
    toilet_nums: '화장실 개수',
    one_toilet: '1개',
    two_toilet: '2개',
    three_toilet: '3개 이상',
    three_toilet1: '3개',
    elevator: '엘리베이터',
    exist: '있음',
    none: '없음',
    trans_type: '거래형태',
    trans_type1: '거래형태',
    trans_type_desc: '*신축현장은 표시된 가격범위를 벗어난 경우 조회되지 않습니다.',
    charter_price: '전세가',
    safe_charter: '안심전세',
    small_business: '중기청',
    man: '만',
    investment: '투자금',
    monthly_rent_deposit: '월세 보증금',
    deposit: '보증금',
    monthly_rent_price: '월세가',
    monthly_rent: '월세가',
    exclusive_area: '전용면적',
    real_area: '실면적',
    unlimited: '무제한',
    py_more: '평 이상',
    fee: '수수료',
    fee1: '수수료(백만원 단위)',
    court: '법정',
    site_check: '현장문의',
    regist_date: '등록일자',
    open_date: '오픈일자',
    open_date2: '준공일자',
    registration_date: '등록일자',
    opening_date: '준공일자(오픈일자)',
    select_period: '기간지정',
    month: '%s개월',
    year: '%s년',
    year1: '년',
    year_month: '%s년 %s개월',
    within: ' 이내',
    before: ' 이전',
    today: '오늘',
    year_before: '년\n이전',
    current_show_sale: '현재 표시된 매물 %s개',
    no_search_result: '검색 결과가 없습니다.',
    no_search_keyword: '검색어를 입력해주세요.',
    no_gps_permission: '현재 위치정보를 얻을 수 없습니다.',
    reset_filter: '필터를 초기화 하시겠습니까?',
    m: '%s달',
    m1: '%s개월',
    y: '%s년',
    site_report: '현장제보',
    site_report2: '불량신고',
    road_view: '로드뷰',
    favorite_sale: '관심매물',
    filter_set: '조건 설정',
    filter_been_set: '조건 설정됨',
    unfold_list: '목록 열기',
    fold_list: '목록 닫기',
    sort_site: '현장 단위',
    sort_ho: '세대 단위',
    sort_price_high: '가격 높은 순',
    sort_price_low: '가격 낮은 순',
    sort_collateral_high: '담보 높은 순',
    sort_collateral_low: '담보 낮은 순',
    site_inquire_display_none: '금액 현장문의 지도에 미표시',
    search_placeholer: '검색: 지역명 현장명 또는 현장 주소',
    road_view_guide: '해당 위치를 클릭하시거나 핀을 직접 이동해주세요.',
    sort_collateral_price_desc: '실입(담보) 입력된 매물만 표시됩니다.',
    show_price_input_site_only_desc: '가격 입력된 매물만 표시됩니다.',
    show_site_inquire_only_desc: '가격 입력되지 않은 매물이 표시됩니다.',
    no_matched_site: '해당 조건에 맞는 매물이 없습니다',
  },
  site_report: {
    search_site_name_placeholder: '현장명 검색',
    site_report: '현장제보',
    unregistered_site: '미등록현장',
    unregister: '[미등록]',
    report_result: '제보결과',
    report_award: '정확한 제보 시 %s포인트가 제공됩니다.',
    report_award_bound: '(단 본인 관리 현장 제외, 신축현장만 해당됩니다.)',
    report_award_exception: '단 본인 관리 현장은 포인트 제공에서 제외됩니다.',
    report_inaccurate_disadvantage: '부정확한 제보는 불이익이 있을 수 있습니다.',
    report_inaccurate_disadvantage1: '현장이 완전히 끝났을 경우에만 제보해주세요.',
    report_exception: '(단 본인 관리 현장 제외, 신축현장만 해당됩니다.)',
    report_exception_unregister: '(이미 등록된 현장 제외, 신축현장만 가능합니다.)',
    report_memo_placeholder: '현장 관련 내용 또는 첨부할 이미지가 있으시면 이용해주세요.',
    site_completion: '현장완료',
    ho_completion: '세대완료',
    ho_wrong: '해약세대',
    site_completion1: '세대완료',
    site_shutdown: '현장중단',
    site_resumption: '현장재개',
    sales_team_change: '분양팀교체',
    price_change: '가격변동',
    reject: '거절',
    payment: '지급',
    site_transfer: '매물이전',
    pay_success: '포인트를 지급하였습니다.',
    reject_success: '포인트 지급을 거절하였습니다.',
    accept_report: '[%s] 확인 - 1000포인트 지급',
    accept_report_ho: '[%s] %s 확인 - 100포인트 지급',
    accept_report_ho1: '[%s] 확인 - 100포인트 지급',
    accept_report_unregister: '[미등록현장] 확인 - %s포인트 지급',
    reject_report: '[%s] 불일치 - 포인트 미지급',
    reject_report_ho: '[%s] %s 불일치 - 포인트 미지급',
    report_btn: '제보하기',
    want_say_manager: '남길 말',
    want_say_manager2: '제보 관련 내용',
    want_say_manager_placeholder: '제보 관련 하실 말씀이 있다면 기재해주세요.',
    ask_report: '제보하시겠습니까?',
    no_report_result: '제보내역이 없습니다.',
    transfer_site_done: '매물이 이전되었습니다.',
    report_house_desc: '세대 관련 제보 시 100P 지급'
  },
  community: {
    all: '전체',
    notice: '공지사항',
    find_site: '현장찾기',
    worker_job: '구인/구직',
    report: '자유게시판',
    report1: '자유',
    title: '제목',
    content: '내용',
    title_content: '제목 + 내용',
    phone: '연락처',
    site: '현장명',
    writing: '글쓰기',
    post_edit: '게시글 수정',
    agree_honest_content_only_desc: '부적절한 내용이 작성될 시 삭제될 수 있습니다.',
    phone_placeholder: '전화번호를 입력하세요.',
    title_placeholder: '제목을 입력하세요.',
    content_placeholder: '내용을 입력하세요.',
    agree_honest_content_only_placeholder: '부적절한 내용의 글이나 그림을 올리지 않는다고 동의해주세요.',
    contacts_input: '연락처정보를 입력하세요.',
    attachments: '파일첨부',
    made_guide: '메이드+ 적용 시 홈 알림 \n상단에 24시간 고정됩니다.',
    push: 'PUSH',
    made_plus: '메이드+',
    writing_possible: '글쓰기 가능건수 %s건',
    anony: '익명',
    anony_writer: '글쓴이',
    writing_limit_desc: '로그인 시\n 하루 %s건이 생성됩니다.',
    push_title: 'PUSH 알림을 이용합니다.',
    push_content: '잔여가 없을 시 포인트 %s점이 소모됩니다.',
    push_content1: '잔여 PUSH %s회',
    made_title: '메이드+를 이용합니다.',
    made_content: '잔여가 없을 시 포인트 %s점이 소모됩니다.\n해당 기능은 글쓰기 가능건수와 무관합니다.\n',
    made_content_1: '잔여가 없을 시 포인트 %s점이 소모됩니다.',
    made_content_2: '해당 기능은 글쓰기 가능건수와 무관합니다.',
    made_content1: '잔여 메이드+ %s회',
    made_content2: '잔여가 없을 시 포인트 %s점이 소모됩니다.\n해당 기능은 알림 가능건수와 무관합니다.\n',
    call: '연락처복사',
    send_msg: '문자전송',
    delete_confirm_title: '선택된 글을 삭제하시겠습니까?',
    delete_confirm: '삭제 시 복구가 불가능합니다.',
    delete_comment_confirm: '작성하신 댓글을 삭제합니다.',
    mine: '내 글',
    comment: '댓글',
    comment_guide: '댓글 등록 시 작성자에게 알림이 전송됩니다.',
    regist: '등 록',
    prevent_btn: '글 차단',
    report_btn: '글 신고',
    prevent_comment_btn: '차단',
    report_comment_btn: '신고',
    ask_prevent: '해당 게시글을 정말 차단하겠습니까?',
    ask_comment_prevent: '해당 댓글을 차단하겠습니까?',
    report_success: '신고되었습니다.',
    report_success1: '제보되었습니다.',
    comment_placeholder: '댓글을 입력해주세요.'
  },
  group: {
    view: '조회',
    transfer_warning_desc: '이전되면 더 이상 매물을 관리하실 수 없습니다.',
    transferred_to_sb: '%s에게 매물을 이전합니다.',
    transfer_phone_placeholder: '이전할 회원번호를 입력하세요.',
    enter_phone_number: '전화번호를 입력해 주세요.',
    enter_group_name: '그룹명을 입력하세요.',
    confirm_destination: '[조희]를 눌러 회원명을 확인해주세요.',
    group_share: '그룹공유',
    share_release: '공유해제',
    no_group: '그룹 없음',
    no_group_msg: '그룹에 속한 회원이 아닙니다.',
    group_member_mng: '그룹회원 관리',
    create_group: '그룹 생성',
    add_group: '그룹추가',
    change_group_name: '그룹명 변경',
    delete_group_member: '회원삭제',
    add_group_member: '회원추가',
    leave_group: '그룹탈퇴',
    name: '이름',
    member_number: '회원번호',
    add_group_member_placeholder: '추가할 회원번호를 입력해주세요.',
    release_site_group_question: '매물을 공유 해제하시겠습니까?',
    no_sites_in_group: '해당 그룹에 매물이 존재하지 않습니다.',
    change_group_name_desc: '새로운 그룹명으로 변경합니다.',
    change_group_name_placeholder: '새 그룹명을 입력해주세요.',
    create_group_title: '그룹 생성',
    create_group_desc: '새로운 그룹을 생성합니다.',
    create_group_placeholder: '그룹명을 입력해주세요.',
    leave_group_question: '해당 그룹을 탈퇴하시겠습니까?',
    delete_group_member_placeholder: '삭제할 회원번호를 입력해주세요.',
    select_group_title: '공유할 그룹을 선택하세요.',
    no_group_involved: '소속된 그룹이 없습니다.',
    select_group: '먼저 그룹을 선택해주세요.',
    share_success: '공유되었습니다.',
    release_success: '해제되었습니다.',
    group_member_can: '그룹원은 매물을 관리할 수 있습니다.',
    share_maemul_to_group: '매물을 그룹에 공유합니다.',
    create_or_invited_group: '그룹을 생성하시거나\n그룹에 초대 받으셔야 합니다.',
    available_notify: '알림 가능건수 %s건',
    not_group_member: '그룹에 속한 회원이 아닙니다.',
  },
  more: {
    show: '표시',
    hide: '숨김',
    days_left: '이용권 %s일 남음',
    extends: '연 장',
    points_remain: '잔여 포인트 %s P',
    auto_hide_waring: "매물의 '자동숨김'까지 %s일 남았습니다.",
    auto_hidden_maemul: "'자동숨김' 처리된 매물입니다.",
    send_noti: '알림보내기',
    noti_modify: '알림수정',
    noti_receive: '오늘받은알림',
    auto_noti: '자동알림',
    sale_regist: '매물등록',
    sale_list: '나의매물',
    sale_complete: '세대완료',
    sale_complete1: '분양완료',
    sale_hidden: '숨김',
    area_calc: '면적계산',
    loan_calc: '대출계산',
    nearby_transport: '주변교통',
    inquire: '문의하기',
    point_charging: '충전하기',
    setting: '설정',
    terms_of_use: '이용약관',
    privacy_policy: '개인정보 처리방침',
    about_us: '회사소개',
    customer_center: '고객센터 %s',
    site_name_placeholder: '현장명을 입력하세요.',
    site_name_placeholder2: '매물명을 입력하세요.',
    site_name_placeholder1: '등록된 현장정보를 연결하세요.',
    address_placeholder: '주소를 입력하세요.',
    link_my_site: '내 현장정보 연결',
    copy_previous_notifications: '이전알림 복사',
    notify_list: '알림목록',
    auto_noti_setting: '자동알림 설정',
    search_address: '주소를 검색하세요.',
    address_search: '주소검색',
    noti_made_content: '메인화면 알림 상단에 24시간 고정됩니다.\n' +
      '잔여횟수가 없을 시 포인트 %s점이 소모됩니다.\n(알림 가능건수와 무관합니다.)' + '\n메이드+ 잔여 횟수 %s회',
    noti_guide: '메이드+ 적용 시 메인 알림\n상단에서 24시간 고정됩니다.',
    noti_tooltip: '알림 가능건수 %s건',
    select_site: '현장 선택',
    no_site: '연결된 현장정보가 없습니다.',
    no_notify: '등록된 현장알림이 없습니다.',
    address_popup_placeholder: '지번, 도로명을 입력하세요.',
    road_name: '도로명',
    set_cur_location: '현 위치로 주소 설정하기',
    detail_address_placeholder: '상세주소를 입력하세요.',
    view_by: '도로명 주소로 보기',
    set_address: '이 위치로 주소 설정',
    sale_registration: '매물등록',
    reg_regist: '등록요청',
    loan_method: '대출방법',
    loan_principal: '대출원금',
    loan_period: '대출기간',
    loan_interest_rate: '대출금리',
    input_all: '모든 정보를 입력하세요',
    division: '구분',
    cal_result: '계산결과',
    avg_monthly_pay: '월 평균 납입금',
    total_interest_paid: '총 납입 이자',
    avg_monthly_interest_amt: '월 평균 이자액',
    view_monthly_payment: '월별 납입금액 보기',
    calculate: '계산하기',
    round: '회차',
    repay_principal_rate: '상환원리금',
    repay_principal: '상환원금',
    monthly_loan_interest: '월대출이자',
    loan_balance: '대출잔액',
    push_vibration: '푸시 진동 온오프',
    push_noti: '푸시 알림 온오프',
    set_noti_disturb: '알림 방해 금지 시간설정',
    start_time: '시작시간',
    end_time: '종료시간',
    set_my_info: '내 정보 설정',
    point_history: '포인트 내역',
    logout: '로그아웃',
    logout_confirm: '정말 로그아웃 하시겠습니까?',
    withdrawal: '회원탈퇴',
    withdraw_title: '정말 메이드를 탈퇴하시겠습니까?',
    withdraw_confirm: '작성한 모든 정보가 삭제됩니다.',
    on_withdrawed: '정상적으로 탈퇴되었습니다.',
    withdraw_phone: '로그인한 휴대폰 번호를 입력하세요.',
    date: '날짜',
    history: '내역',
    inc_or_dec: '포인트 증감',
    remain_point: '잔여 포인트',
    charge_point: '포인트 충전',
    charge_point1: '충전 포인트',
    bonus: '+%s% 보너스',
    payment_method: '결제 수단',
    credit_card: '신용카드',
    kt_pay: '카카오페이',
    point_remain: '잔여 포인트 %s P',
    account_copy_button: '계좌복사',
    account_send: '알려주기',
    account_text: '충전 방식이 어렵다면 계좌이체 하러 가기',
    account_title: '계좌이체',
    account_bank: 'KB국민은행',
    account_no: '482601-01-158927',
    account_guide_1: '충전하실 금액을 계좌이체 하신 후,',
    account_guide_2: '<span class="account_guide_span">성함</span>과 <span class="account_guide_span">충전하실 연락처</span>를 알려주세요.',
    account_guide_3: 'EX) 홍길동 010-1234-5678',
    account_notice1: '5만원 이상 충전 시 10%의 포인트가 추가로 제공됩니다.',
    account_notice2: '이체 금액은 부가세(10%)를 포함해야 합니다.',
    account_notice3: '현금영수증, 세금계산서 발행 가능합니다.',
    account_copy: 'KB국민은행 메이드 482601-01-158927',
    go_transfer_account: '충전 방식이 어렵다면 계좌이체 하러 가기',
    total_pay_amount: '총 결제 금액 (VAT 포함)',
    charging: '충전하기',
    vat: '(VAT 포함)',
    load_temporary_save: '임시저장된 정보를 불러오시겠습니까?',
    usage_extension: '구매하기',
    d_usage: '%s일 이용권',
    point: '%s P',
    gae: '%s회',
    made_remain_gae: ' 잔여 메이드+ %s회',
    push_remain_gae: '잔여 PUSH %s회',
    payment_point: '결제 포인트',
    purchase: '구매하기',
    point_not_enough: '잔여 포인트가 부족합니다.',
    point_purchase: '포인트를 충전하시겠습니까?',
    usage_expired_title: '이용기간이 없습니다.',
    usage_expired: '이용권을 구매하시겠습니까?',
    usage_success: '구매가 완료되었습니다.',
    no_point_payment: '충전하실 금액을 선택해주세요.'
  },
  notify: {
    today_list: '알림목록',
    site_name: '현장명',
    location: '위치',
    contact: '연락처',
    contact1: '현장 연락처',
    site_info: '현장정보',
    noti_content: '내용',
    read_all: '전체읽음',
    delete_title: '선택한 알림을 삭제하시겠습니까?',
    delete_confirm: '삭제한 알림은 복구가 불가능합니다.',
    save_success: '알림이 등록되었습니다.',
    auto_noti_title: '자동알림 설정%s',
    auto_noti_interval: '알림 발송 간격',
    auto_noti_time: '알림 발송 시간',
    auto_noti_every_day: '매일',
    auto_noti_3_day: '3일',
    auto_noti_5_day: '5일',
    create_auto_notify: '자동알림 생성',
    ask_delete_auto_notify: '선택한 자동알림을 삭제하시겠습니까?',
  },
  inquire: {
    sale_register: '매물등록',
    usage: '사용방법',
    ads: '광고문의',
    community: '커뮤니티',
    point: '포인트충전',
    point1: '포인트',
    other: '기타문의',
    save: '저장',
    secret: '비밀글',
    news: '알림',
    answer: '답변',
    answer_placeholder: '답변내용을 입력해주세요.',
    answer_success: '답변이 등록되었습니다.',
    delete_confirm: '이 문의내용을 삭제하시겠습니까?',
    mine: '내 문의',
    secret_inquire: '비밀글입니다. 본인만 확인가능합니다.',
    answer_complete: '[답변완료]'
  },
  complete: {
    toggle_site_complete: '세대완료 설정/해제',
    sold_out_hint: '메이드는 항상 현장의 완판을 기원합니다.',
    sold_out_hint_desc: '개별 호수를 눌러 세대완료/해제를 지정할 수 있습니다.\n적용된 정보는 등록한 매물 정보에 업데이트 됩니다.'
  },
  register: {
    reg_new_open_site: '신축현장 등록',
    site_name: '현장명',
    site_name1: '매물명',
    address: '주소',
    search_address: '주소검색',
    add: '추가',
    complex_info: '단지정보',
    total: ' 총',
    gae_dong: '개동  /',
    household: '세대',
    million_man_won: '백만원',
    single_hit: '단타',
    double_hit: '양타',
    none_hit: '없음',
    inlay_reg: '속지 등록',
    private: '비공개',
    memo_guide: '매물에 관련된 내용을 입력해주세요.',
    memo_guide1: '현장에 관련된 내용을 입력해주세요.',
    memo_guide2: '해당 세대에 관련된 내용을 적어주세요.',
    temporary_save: '임시저장',
    east_floor: '동/층/세대 정보',
    east_floor2: '(단일 동일 경우 동에 ‘1’ 기재)',
    reg_represent_photo: '대표 현장사진 등록',
    reg_photo_guide: '첫 번째 사진이 대표 사진으로 등록됩니다.',
    memo_placeholder: '현장 메모를 적어주세요.',
    on_site_photo_reg: '현장사진 등록',
    on_site_photo_reg1: '매물사진 등록',
    modify_new_open_site: '신축현장 수정',
    modify_general_sale: '구옥매물 수정',
    register_general_sale: '구옥매물 등록',
    modify_unregistered_site: '미등록현장 수정',
    view_unregistered_site: '미등록현장 보기',
    contact_placeholder: '연락처정보를 입력하세요.',
    complex_info_placeholder: '단지정보를 입력하세요.',
    maemul_type_placeholder: '매물유형을 설정하세요.',
    trans_type_placeholder: '거래형태를 설정하세요.',
    trans_cost_placeholder: '거래값을 입력하세요.',
    trans_cost_placeholder1: '금액정보가 입력되지 않았습니다.',
    room_num_placeholder: '방 개수를 설정하세요.',
    toilet_num_placeholder: '화장실 개수를 설정하세요.',
    veranda_num_placeholder: '베란다 개수를 설정하세요.',
    utility_room_num_placeholder: '다용도실 개수를 설정하세요.',
    elevator_placeholder: '엘리베이터 정보를 설정하세요.',
    area_placeholder: '면적유형을 선택하세요.',
    area_info_placeholder: '면적정보를 입력하세요.',
    fee_type_placeholder: '수수료를 설정해주세요.',
    fee_info_placeholder: '수수료 정보를 입력해주세요.',
    dong_name_placeholder: '동이름을 입력하세요.',
    limited_ho_count: '세대정보를 더 추가할 수 없습니다.',
    dong_limited_ho_count: '이 동에 세대정보를 더 추가할 수 없습니다.',
    copy_floor_ho_count_not_match: '복사 받을 층의 세대 수가 없거나 \n동일한 세대 수가 입력되어 있어야 합니다.',
    copy_floor_ho_count_not_match1: '먼저 복사 받을 세대 수를 동일하게 설정해주세요.',
    copy_src_empty: '복사원천층에 세대가 없습니다.',
    save: '작성완료',
    dong: '동',
    floor: '층',
    line: '라인',
    input: '입력%s',
    ho: '호',
    ho_input: '동 세대 입력',
    ho_input_desc: '필로티 구조는 2층부터 입력',
    copy_info: '층 정보를',
    to_this_floor: '층에 그대로 복사',
    to_this_floor1: '층에 ',
    all_info: '전체정보',
    only_photo: '사진만',
    apply: '적용',
    room: '방',
    toilet: '화장실',
    toilet1: '화',
    parcel_out: '매매',
    exclusive_size: '전용면적',
    exclusive: '전용',
    real_size: '실면적',
    real_size1: '실평',
    ho_name: '호수명',
    ho_name_hint: '명칭수정가능',
    million_man_won2: '만원',
    ho_memo_hint: '해당 세대에 설명이 필요하면 적어주십시오.',
    multi_select: '중복선택가능',
    unit_money: ' (단위 1 = 100만원)',
    unit_money2: ' (단위 1 = 100만원, 중복 선택 가능)',
    r_residence: '실거주',
    structure: '구조',
    unspecified: '미기재',
    trading_price: '매매 금액',
    charter_price: '전세 금액',
    invest_price: '투자 금액',
    trading_fee: '매매 수수료',
    charter_fee: '전세 수수료',
    monthly_fee: '월세 수수료',
    invest_fee: '투자 수수료',
  },
};



// WEBPACK FOOTER //
// ./src/i18n/locales/ko.js